export default __webpack_public_path__ + "assets/images/5e569bc1979d87aa51cb4ed548517129.jpg";